import script from "./SubTaskItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SubTaskItem.vue?vue&type=script&setup=true&lang=js"

import "./SubTaskItem.vue?vue&type=style&index=0&id=17287610&scoped=true&lang=css"
import "./SubTaskItem.vue?vue&type=style&index=1&id=17287610&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17287610"]])

export default __exports__